import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
import { Source } from '@gonfalon/metric-events/Sources';
import { isLDHosted } from '@gonfalon/metrics/isLDHosted';
import type { EventActivityResponseItem } from '@gonfalon/metrics/types';
import { Icon } from '@launchpad-ui/icons';
import clsx from 'clsx';

import styles from './EventActivityResultsSidePanel.module.css';

type EventActivityResultsSidePanelProps = {
  event: EventActivityResponseItem;
};

export const EventActivityResultsSidePanel: React.FC<EventActivityResultsSidePanelProps> = ({
  event,
}: EventActivityResultsSidePanelProps) => {
  const seenInEnvironments = (
    <div className={styles.detailsContainer}>
      <Message id="metrics.eventKeyField.seenIn" />
      {event.environments?.slice(0, 2).map((e) => (
        <div key={e.environmentKey} className={styles.listContainer}>
          <span className={styles.envSpan}>
            <Icon style={{ fill: `#${e.color}` }} name="circle" size="tiny" /> {e.name}
          </span>
        </div>
      ))}
      {event.environments?.length &&
        event.environments?.length > 2 &&
        msg('metrics.eventKeyField.more', { count: event.environments.length - 2 })}
    </div>
  );

  const contextKinds = (
    <div className={styles.detailsContainer}>
      <Message id="metrics.eventKeyField.contexts" />
      {event.contextKinds?.slice(0, 3).map((contextKind) => (
        <div key={contextKind} className={styles.listContainer}>
          <span className={styles.code}>{contextKind}</span>
        </div>
      ))}
      {event.contextKinds?.length &&
        event.contextKinds?.length > 3 &&
        msg('metrics.eventKeyField.more', { count: event.contextKinds.length - 3 })}
    </div>
  );

  const eventSources = (
    <div className={clsx(styles.detailsContainer, styles.sources)}>
      <Message id="metrics.eventKeyField.sources" values={{ count: event.sources?.length ?? 0 }} />{' '}
      {(event.sources ?? []).slice(0, 2).map((source) => (
        <Source key={source} className={styles[source]} sourceKey={source} variant="small" />
      ))}
      {event.sources?.length &&
        event.sources?.length > 2 &&
        msg('metrics.eventKeyField.more', { count: event.sources.length - 2 })}
    </div>
  );

  const dataSource = (
    <div className={clsx(styles.detailsContainer, styles.sources)}>
      <Message id="metrics.eventKeyField.dataSourceLabel" />{' '}
      <Source
        key={event?.dataSource?.key}
        sourceKey={event?.dataSource?.key || ''}
        sourceName={event?.dataSource?.name}
        variant="small"
      />
    </div>
  );

  const sources = !isLDHosted(event.dataSource?.key) ? dataSource : eventSources;

  return (
    <div className={styles.tooltipContentWrapper}>
      {seenInEnvironments}
      {contextKinds}
      {(event.sources || event.dataSource) && sources}
    </div>
  );
};
